import { api } from "../Configurations/axios";

//Get:
const GetAllBanks = async () => {
    try {
        const result = await api.get(`/Bank/GetAll`);
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}


export {
    GetAllBanks
}